import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Modal } from '@liveauctioneers/hammer-ui-core/modal';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    setShowModal: (value: boolean) => void;
    showModal: boolean;
};

export const PaysafeModal = ({ setShowModal, showModal }: Props) => {
    const formatMessage = useAppFormatMessage();
    const isMobile = useIsMobileLayout();

    return (
        <Modal
            actions={
                <Button
                    className={cn(isMobile ? 'w-full' : 'w-[264px]')}
                    onClick={() => {
                        setShowModal(false);
                    }}
                >
                    <FormattedMessage id="accountSettings.gotIt" />
                </Button>
            }
            body={
                <>
                    <div className={cn('text-center', isMobile ? 'mb-md' : 'mb-lg')}>
                        <FormattedMessage id="accountSettings.paysafeMessageOne" />
                    </div>
                    <div className="text-center">
                        <FormattedMessage id="accountSettings.paysafeMessageTwo" />
                    </div>
                </>
            }
            data-testid="paysafeModal"
            handleClose={() => {
                setShowModal(false);
            }}
            show={showModal}
            title={formatMessage(['accountSettings', 'openModal'])}
        />
    );
};
